module.exports = __webpack_public_path__ + "img/formal-background.50d03f40.png";